var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.25a2.25 2.25 0 114.502.002A2.25 2.25 0 013 5.25zM15.15 8.4c-3.23 0-5.85 2.604-5.85 5.814V20.1c0 .497.403.901.9.901h2.1a.902.902 0 00.9-.9v-5.886c0-1.136.984-2.044 2.152-1.927 1.014.101 1.747 1.028 1.747 2.047V20.1c0 .497.404.901.901.901h2.1a.902.902 0 00.9-.9v-5.886c0-3.21-2.62-5.814-5.85-5.814zm-8.55.9H3.9a.9.9 0 00-.9.9v9.9a.9.9 0 00.9.9h2.7a.9.9 0 00.9-.9v-9.9a.9.9 0 00-.9-.9z",
    fill: "#231F20"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "linkedin_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 20,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.25a2.25 2.25 0 114.502.002A2.25 2.25 0 013 5.25zM15.15 8.4c-3.23 0-5.85 2.604-5.85 5.814V20.1c0 .497.403.901.9.901h2.1a.902.902 0 00.9-.9v-5.886c0-1.136.984-2.044 2.152-1.927 1.014.101 1.747 1.028 1.747 2.047V20.1c0 .497.404.901.901.901h2.1a.902.902 0 00.9-.9v-5.886c0-3.21-2.62-5.814-5.85-5.814zm-8.55.9H3.9a.9.9 0 00-.9.9v9.9a.9.9 0 00.9.9h2.7a.9.9 0 00.9-.9v-9.9a.9.9 0 00-.9-.9z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#linkedin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A3F6E",
    d: "M0 0h24v24H0z"
  }))));
}

export default SvgLinkedin;